import React, { useState } from 'react';
import '../../assets/css/components/help_button.css';

const HelpButton = ({ onClick, position = 'bottom-right' }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            className={`help-button ${position} ${isHovered ? 'hovered' : ''}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            aria-label="Get help"
            title="Take a tour"
        >
            <span className="help-icon">?</span>
            <span className="help-text">Help</span>
        </button>
    );
};

export default HelpButton;
